import { createSelector } from '@reduxjs/toolkit';
import { fromBase64 } from '../../shared/util/base64';
import { getLocationsSelectorArgs } from '../../service/locations/selectors/getRegionSelector';

export const getDeviceByBase64DeviceIdSelector = createSelector(
  [
    getLocationsSelectorArgs,
    (_state, props: { deviceId?: string }) => props.deviceId,
  ],
  (locations, deviceBase64Id) => {
    if (!deviceBase64Id) return undefined;
    const deviceId = fromBase64(deviceBase64Id);
    const location = locations.data?.devices.find(
      (device) => device.uuid === deviceId
    );
    return location;
  }
);
